import Trans from 'next-translate/Trans';

import { Box, Line, LinkTranslatedStyledAsLink, Typography } from '@core/component';
import { Translate } from '@core/constant';
import { useContextMediaQuery } from '@core/context';
import { useLanguage } from '@core/hook';
import {
  EActionAttribute,
  EColor,
  EDateFormat,
  EFontWeight,
  ERouting,
  ETypographyVariant,
} from '@core/type';
import { SanityBlogArticle } from '@core/type/sanity';
import { formatDate } from '@core/util';

import { BlogSocialLinks } from '../BlogSocialLinks';

export const BlogArticleHead = ({
  title,
  subtitle,
  body: { category, readingTime, publishedAt },
}: SanityBlogArticle) => {
  const { language } = useLanguage();
  const { isPhone } = useContextMediaQuery();

  return (
    <>
      <Typography as={EActionAttribute.H1} variant={ETypographyVariant.H1} textAlign={'center'}>
        {title}
      </Typography>

      <Box display={'flex'} alignItems={'center'} marginTop={isPhone ? '16px' : '24px'}>
        <LinkTranslatedStyledAsLink
          keyRoute={ERouting.BLOG_CATEGORY}
          query={{ slug: category?.pageSlug?.slug.current }}
          variant={ETypographyVariant.BODY3}
          color={EColor.SECONDARY}
          fontWeight={EFontWeight.MEDIUM}
        >
          {category?.title}
        </LinkTranslatedStyledAsLink>

        <Line
          isVertical
          margin={'0 16px'}
          height={'14px'}
          color={{ commonType: EColor.GRAY, intensity: EColor.R700 }}
        />

        {!!readingTime && (
          <>
            <Typography variant={ETypographyVariant.BODY3} color={EColor.SECONDARY}>
              {readingTime === 1 ? (
                <Trans i18nKey={`${Translate.common.PRODUCT}:timeLeft.oneMinuteRead`} />
              ) : (
                <Trans
                  i18nKey={`${Translate.common.PRODUCT}:timeLeft.minutesRead`}
                  values={{ minutes: readingTime }}
                />
              )}
            </Typography>

            <Line
              isVertical
              margin={'0 16px'}
              height={'14px'}
              color={{ commonType: EColor.GRAY, intensity: EColor.R700 }}
            />
          </>
        )}

        <Typography variant={ETypographyVariant.BODY3} color={EColor.SECONDARY}>
          {formatDate(publishedAt, language, EDateFormat.ddMMyyyy)}
        </Typography>
      </Box>

      {isPhone && (
        <Box display={'flex'} gap={'24px'} flexDirection={'row'} marginTop={'32px'}>
          <BlogSocialLinks title={title} subtitle={subtitle} />
        </Box>
      )}
    </>
  );
};
